import styled from '@emotion/styled';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';

export const StyledListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--rk-spacing-xl);
  padding: 0 0 var(--rk-spacing-xxxxxxxxxxxxxxxl) 0;

  ${mq(BreakpointSizes.desktop)} {
    padding: 0 0 var(--rk-spacing-xxxxxxl) 0;
  }
`;
